import type { WeaponEstimate } from "./WeaponEstimate.type"

export default function isValidWeaponEstimate(we: WeaponEstimate) {
  return we.errors.length === 0
}